/**
 * 母の日＆父の日キャンペーン用の処理
 * 終了したら削除する
 */
import dayjs from "dayjs"
import { ProductFragmentFragment, SkuFragmentFragment } from "~/types/type.generated"

type Novelty = {
  img: string
  text: string
  note: string
  skuIds: string[]
  isInStock: boolean
}

export type GiftSetProduct = {
  title: string
  subTitle: string
  productNames: string
  description: string
  bannerSp?: string
  bannerPc?: string
  novelty?: Novelty
  discountLate?: number
  selectedProducts: string[]
  isNewItem: boolean
  bakuneCategory: boolean
  products: {
    selectLabel?: string
    selectItems: {
      index: number
      documentId: string
      skuName?: string
      selectName: string
      productName: string
      subtext: string
      img: string
      price?: number
      isInStock: boolean
      disabled?: boolean
    }[]
  }[]
  products_note?: string
  urlTable: {
    documentIds: string[]
    url: string
  }[]
  otherItem?: {
    title: string
    url: string
  }
}

export type RecommendProduct = {
  document_id: string
  name: string
  subText: string
  img: string
  isInStock: boolean
  price?: number
  url?: string
}

export type APIResponse = {
  products: ProductFragmentFragment[]
  skus: SkuFragmentFragment[]
}

/**
 * ノベルティ情報
 */
const noveltyPairHandTowel = {
  img: "/images/site/feature/mothers-fathers-day-2025/novelty-1.png",
  text: "数量限定でオリジナルハンドタオルをペアでプレゼント!",
  note: "※カラーはお任せください。\n※なくなり次第終了します。",
  skuIds: ["6801bdad49f50cb1fbcce961"],
  isInStock: true,
}

const noveltySleepMist = {
  img: "/images/site/feature/mothers-fathers-day-2025/novelty-2.png",
  text: "この春新発売の\nBAKUNEスリープミスト限定ミニサイズを数量限定でプレゼント！",
  note: "※10mlサイズ・デザインは異なります。\n※なくなり次第終了します。",
  skuIds: ["67f5cd5dab393211e7d6fba1"],
  isInStock: true,
}

const noveltyHandTowel = {
  img: "/images/site/feature/mothers-fathers-day-2025/novelty-3.png",
  text: "数量限定でオリジナルハンドタオルをプレゼント！",
  note: "※カラーはお任せください。\n※なくなり次第終了します。",
  skuIds: ["67f5cd9eab393211e7d6feba", "67f5cd9eab393211e7d6febb"],
  isInStock: true,
}

const noveltyTeeSet = {
  img: "/images/site/feature/mothers-fathers-day-2025/novelty-4.png",
  text: "数量限定で TENTIAL ORIGINAL TOUR TEE SET をプレゼント！",
  note: "※なくなり次第終了します。",
  // TODO: 決まったら設定する
  skuIds: [""],
  isInStock: true,
}

// 母の日キャンペーンのギフトコレクションに表示する商品
export const giftSetProductsForMothersDay = <GiftSetProduct[]>[
  {
    title: "両親に仲良く一緒に着てほしい",
    subTitle: "選べるおそろい機能性パジャマ",
    productNames: "BAKUNEペアパジャマセット",
    description:
      "母の日＆父の日を一緒にお祝い。仲良しの両親に「ありがとう」の想いを込めて贈る「BAKUNE Dryペアパジャマセット」。サラッとした肌触りの良い素材で、ちょっとイマドキなスポーティさがあるだけでなく、睡眠環境を向上させてくれる”機能性で健康をささえる”おそろいペアギフトです。",
    bakuneCategory: true,
    novelty: noveltyPairHandTowel,
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-bakune-sp.png",
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-bakune-pc.png",
    discountLate: 10,
    selectedProducts: dayjs().isAfter("2025-05-03 09:00") ? ["0", "0"] : ["2", "2"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Dry Men's",
        selectItems: [
          {
            index: 0,
            documentId: "67be9311f7605c28867c7f5d",
            selectName: "長袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(長袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-long.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67f8b05674581f45ba3a5ba3",
            selectName: "半袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short-and-long.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67ca6adcce9a365145b38d0c",
            selectName: "半袖Tシャツ＋ショートパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Dry Women's",
        selectItems: [
          {
            index: 0,
            documentId: "67be95bff7605c28867d04bf",
            selectName: "長袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(長袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-long.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67f8b12874581f45ba3a68c5",
            selectName: "半袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short-and-long.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67ca7b8ace9a365145b4d9a7",
            selectName: "半袖Tシャツ＋ショートパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67be9311f7605c28867c7f5d", "67be95bff7605c28867d04bf"],
        url: "/features/mothers-fathers-day-2025-bakuneset-01",
      },
      {
        documentIds: ["67be9311f7605c28867c7f5d", "67f8b12874581f45ba3a68c5"],
        url: "/features/mothers-fathers-day-2025-bakuneset-09",
      },
      {
        documentIds: ["67be9311f7605c28867c7f5d", "67ca7b8ace9a365145b4d9a7"],
        url: "/features/mothers-fathers-day-2025-bakuneset-04",
      },
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67be95bff7605c28867d04bf"],
        url: "/features/mothers-fathers-day-2025-bakuneset-05",
      },
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67f8b12874581f45ba3a68c5"],
        url: "/features/mothers-fathers-day-2025-bakuneset-07",
      },
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67ca7b8ace9a365145b4d9a7"],
        url: "/features/mothers-fathers-day-2025-bakuneset-06",
      },
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67be95bff7605c28867d04bf"],
        url: "/features/mothers-fathers-day-2025-bakuneset-03",
      },
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67f8b12874581f45ba3a68c5"],
        url: "/features/mothers-fathers-day-2025-bakuneset-08",
      },
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67ca7b8ace9a365145b4d9a7"],
        url: "/features/mothers-fathers-day-2025-bakuneset-02",
      },
    ],
    otherItem: {
      title: "他にもあります！\n10%OFFで購入できる「BAKUNEペアパジャマ」",
      url: "/campaign/bakune_set",
    },
  },
  {
    title: "暑い夏の寝苦しさから解放してくれる",
    subTitle: "BAKUNE Dry ＋ 夏用掛け布団",
    productNames: "快適睡眠環境セット",
    description:
      "いつも自分の事は後回しで、家族の事ばかり優先しているお母さんに、日頃言えない「ありがとう」の想いを込めて。夏の夜の寝苦しさから解放してくれる、快適な睡眠環境を贈ってみませんか。BAKUNE Dryパジャマと夏用掛け布団のセットは、いつも優しいお母さんに、温かい想いを伝えてくれる、期間限定の特別セットです。",
    bakuneCategory: true,
    novelty: noveltySleepMist,
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Dry Women's / Men's",
        selectItems: [
          {
            index: 0,
            documentId: "67f8b12874581f45ba3a68c5",
            selectName: "Women's （半袖Tシャツ＋ロングパンツ）",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short-and-long.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67f8b05674581f45ba3a5ba3",
            selectName: "Men's （半袖Tシャツ＋ロングパンツ）",
            productName: "BAKUNE Dry Men’s",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short-and-long.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Comforter Cool （掛け布団）",
        selectItems: [
          {
            index: 0,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67bed5ea46cc55e963fefea2"],
        url: "/features/mothers-fathers-day-2025-comforterset-01",
      },
      {
        documentIds: ["67f8b12874581f45ba3a68c5", "67bed5ea46cc55e963fefea2"],
        url: "/features/mothers-fathers-day-2025-comforterset-02",
      },
    ],
  },
  {
    title: "暑い夏の寝苦しさから解放してくれる",
    subTitle: "BAKUNE Dry ＋ 夏用敷きパッド",
    productNames: "快適涼感セット",
    description:
      "昔から仕事が忙しくて帰りが遅かったお父さん。家にいる時くらいは、ゆっくりと快適な時間を過ごして欲しい。これから暑くなる季節にぴったりなBAKUNE Dryパジャマと敷きパッドのセットで快適な睡眠環境をプレゼント。温度調整素材×除湿素材×ひんやりニットで、朝まで快適に眠れますように。",
    bakuneCategory: true,
    novelty: noveltySleepMist,
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Dry Women's / Men's",
        selectItems: [
          {
            index: 0,
            documentId: "67ca7b8ace9a365145b4d9a7",
            selectName: "Women's （半袖Tシャツ＋ショートパンツ）",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67ca6adcce9a365145b38d0c",
            selectName: "Men's （半袖Tシャツ＋ショートパンツ）",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Bed Pad Cool （敷きパッド）",
        selectItems: [
          {
            index: 0,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67bedac346cc55e963ff2281"],
        url: "/features/mothers-fathers-day-2025-bedpadset-01",
      },
      {
        documentIds: ["67ca7b8ace9a365145b4d9a7", "67bedac346cc55e963ff2281"],
        url: "/features/mothers-fathers-day-2025-bedpadset-02",
      },
    ],
  },
  {
    title: "定番ギフトのポロシャツに機能性をプラス",
    subTitle: "疲労軽減効果のある「MIGARUポロ」",
    productNames: "MIGARUポロシャツ",
    description:
      "休日はもちろん、最近はポロシャツで出勤しているお父さん。見た目や着心地はもちろん、暑い夏を快適に過ごして欲しいから今年はMIGARUのポロシャツを選びました。仕事中も快適で、さらに身体をリカバリーしてくれるから、趣味に仕事に毎日忙しくしているお父さんの健康をしっかりサポートしてくれるはず。",
    bakuneCategory: false,
    novelty: noveltyHandTowel,
    selectedProducts: ["0"],
    isNewItem: false,
    products: [
      {
        selectItems: [
          {
            index: 0,
            documentId: "67ca660dce9a365145b2be95",
            selectName: "MIGARU ポロシャツ",
            productName: "MIGARU ポロシャツ",
            subtext: "ポロシャツ",
            img: "/images/site/feature/mothers-fathers-day-2025/migaru-light-knit-short-sleeve-polo-shirt-25ss.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67ca6b49ce9a365145b39f9f",
            selectName: "MIGARU テーラードポロシャツ",
            productName: "MIGARU テーラードポロシャツ",
            subtext: "ポロシャツ",
            img: "/images/site/feature/mothers-fathers-day-2025/migaru-light-knit-short-sleeve-tailored-polo-shirt-25ss.png",
            isInStock: true,
          },
        ],
      },
    ],
    products_note: "左胸にロゴがあるMIGARUポロシャツと、\nシックなテーラードポロシャツの２種類をご用意しています。",
    urlTable: [
      {
        documentIds: ["67ca660dce9a365145b2be95"],
        url: "/products/migaru-light-knit-25ss-short-polo-shirt",
      },
      {
        documentIds: ["67ca6b49ce9a365145b39f9f"],
        url: "/products/migaru-light-knit-short-tailored-polo-shirt",
      },
    ],
  },
  {
    title: "理想的な寝床内環境を実現してくれる",
    subTitle: "夏用敷きパッド ＋ 掛け布団",
    productNames: "至福の寝具セット",
    description:
      "「よく眠れなかった」が口癖のお父さんにぴったりの新提案ギフト。BAKUNE Bed Pad Coolは暑さや蒸れ、冷房による寒さなど夏の睡眠課題を解決する新発想の敷きパッド。夏用掛け布団は、温度調整素材がエアコンによる肌寒さを防ぎ快適な寝床内環境にコンディショニング。暑いときは涼しく、ただ寒くなりすぎない理想的な寝床内温度へ近づけます。朝まで快適な睡眠環境を手に入れられる夏用寝具セットでお父さんに心地よい休息を届けましょう。",
    bakuneCategory: false,
    novelty: noveltySleepMist,
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-comforter-pc.png",
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-comforter-sp.png",
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Comforter Cool （掛け布団）",
        selectItems: [
          {
            index: 0,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Bed Pad Cool （敷きパッド）",
        selectItems: [
          {
            index: 0,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67bed5ea46cc55e963fefea2", "67bedac346cc55e963ff2281"],
        url: "/features/mothers-fathers-day-2025-comforterbedpadset",
      },
    ],
  },
  {
    title: "両親の健康を足元からささえる",
    subTitle: "リカバリーサンダル",
    productNames: "リカバリーサンダルペアセット",
    description:
      "両親には、いつまでも自分の足で元気に歩いてほしい――そんな願いを込めて贈るなら、アーチサポート構造を採用した「リカバリーサンダルペアセット」がおすすめです。室内、屋外を問わず、至福のやさしい履き心地で、軽やかなフットワークと健康をささえます。",
    bakuneCategory: false,
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-sandal-pc.png",
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-sandal-sp.png",
    discountLate: 10,
    selectedProducts: ["0", "1"],
    isNewItem: false,
    products: [
      {
        selectLabel: "1商品目",
        selectItems: [
          {
            index: 0,
            documentId: "67a3241473eead61841a241e",
            selectName: "Recovery Sandal Slide",
            productName: "Recovery Sandal Slide",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-slide.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "646d68ac7a3fbe961f40794f",
            selectName: "Recovery Sandal Flip-flop",
            productName: "Recovery Sandal Flip-flop",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-flip-flop.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "2商品目",
        selectItems: [
          {
            index: 0,
            documentId: "67a3241473eead61841a241e",
            selectName: "Recovery Sandal Slide",
            productName: "Recovery Sandal Slide",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-slide.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "646d68ac7a3fbe961f40794f",
            selectName: "Recovery Sandal Flip-flop",
            productName: "Recovery Sandal Flip-flop",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-flip-flop.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67a3241473eead61841a241e", "67a3241473eead61841a241e"],
        url: "/features/mothers-fathers-day-2025-sandalset-02",
      },
      {
        documentIds: ["67a3241473eead61841a241e", "646d68ac7a3fbe961f40794f"],
        url: "/features/mothers-fathers-day-2025-sandalset-01",
      },
      {
        documentIds: ["646d68ac7a3fbe961f40794f", "646d68ac7a3fbe961f40794f"],
        url: "/features/mothers-fathers-day-2025-sandalset-03",
      },
    ],
    otherItem: {
      title: "他にもあります！\n10%OFFで購入できる「リカバリーペアサンダル」",
      url: "/features/sandal_set_2023",
    },
  },
]

// 母の日キャンペーンのギフトコレクションに表示する商品（父の日の商品はまだ未確定）
export const giftSetProductsForFathersDay = <GiftSetProduct[]>[
  {
    title: "定番ギフトのポロシャツに機能性をプラス",
    subTitle: "疲労軽減効果のある「MIGARUポロ」",
    productNames: "MIGARUポロシャツ",
    description:
      "休日はもちろん、最近はポロシャツで出勤しているお父さん。見た目や着心地はもちろん、暑い夏を快適に過ごして欲しいから今年はMIGARUのポロシャツを選びました。仕事中も快適で、さらに身体をリカバリーしてくれるから、趣味に仕事に毎日忙しくしているお父さんの健康をしっかりサポートしてくれるはず。",
    bakuneCategory: false,
    novelty: noveltyHandTowel,
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-polo-shirt-pc.png",
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-polo-shirt-sp.png",
    selectedProducts: ["0"],
    isNewItem: false,
    products: [
      {
        selectItems: [
          {
            index: 0,
            documentId: "67ca660dce9a365145b2be95",
            selectName: "MIGARU ポロシャツ",
            productName: "MIGARU ポロシャツ",
            subtext: "ポロシャツ",
            img: "/images/site/feature/mothers-fathers-day-2025/migaru-light-knit-short-sleeve-polo-shirt-25ss.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67ca6b49ce9a365145b39f9f",
            selectName: "MIGARU テーラードポロシャツ",
            productName: "MIGARU テーラードポロシャツ",
            subtext: "ポロシャツ",
            img: "/images/site/feature/mothers-fathers-day-2025/migaru-light-knit-short-sleeve-tailored-polo-shirt-25ss.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67ca660dce9a365145b2be95"],
        url: "/products/migaru-light-knit-25ss-short-polo-shirt",
      },
      {
        documentIds: ["67ca6b49ce9a365145b39f9f"],
        url: "/products/migaru-light-knit-short-tailored-polo-shirt",
      },
    ],
  },
  // TODO: 父の日リリース前には設定する
  {
    title: "最先端テクノロジー搭載",
    subTitle: "シーンを選ばない洗練ゴルフウェア",
    productNames: "アクティブゴルフセット",
    description:
      "ゴルフが大好きなお父さん。私もいつかは一緒にラウンドしてみたい。お父さんのゴルフの時間がもっと快適になればいいなと思って、TENTIALの新作ゴルフウェアを選びました。このセットアップはプレーはもちろん、タウンでも使えるマルチユースデザイン。伸縮性が高く軽量なストレスフリー素材に最新テクノロジー「AddElm」が軽微な皮膚刺激によりスイングをサポート。次のゴルフで、ベストスコア更新かな。",
    bakuneCategory: false,
    novelty: noveltyTeeSet,
    selectedProducts: ["0"],
    isNewItem: true,
    products: [
      {
        selectLabel: "BAKUNE Dry Men's",
        selectItems: [
          {
            index: 0,
            documentId: "67be9311f7605c28867c7f5d",
            selectName: "長袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(長袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/migaru-light-knit-short-sleeve-polo-shirt-25ss.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [],
  },
  {
    title: "両親に仲良く一緒に着てほしい",
    subTitle: "選べるおそろい機能性パジャマ",
    productNames: "BAKUNEペアパジャマセット",
    description:
      "母の日＆父の日を一緒にお祝い。仲良しの両親に「ありがとう」の想いを込めて贈る「BAKUNE Dryペアパジャマセット」。サラッとした肌触りの良い素材で、ちょっとイマドキなスポーティさがあるだけでなく、睡眠環境を向上させてくれる”機能性で健康をささえる”おそろいペアギフトです。",
    bakuneCategory: true,
    novelty: noveltyPairHandTowel,
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-bakune-sp.png",
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-bakune-pc.png",
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Dry Men's",
        selectItems: [
          {
            index: 0,
            documentId: "67be9311f7605c28867c7f5d",
            selectName: "長袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(長袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-long.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67f8b05674581f45ba3a5ba3",
            selectName: "半袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short-and-long.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67ca6adcce9a365145b38d0c",
            selectName: "半袖Tシャツ＋ショートパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Dry Women's",
        selectItems: [
          {
            index: 0,
            documentId: "67be95bff7605c28867d04bf",
            selectName: "長袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(長袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-long.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67f8b12874581f45ba3a68c5",
            selectName: "半袖Tシャツ＋ロングパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short-and-long.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67ca7b8ace9a365145b4d9a7",
            selectName: "半袖Tシャツ＋ショートパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67be9311f7605c28867c7f5d", "67be95bff7605c28867d04bf"],
        url: "/features/mothers-fathers-day-2025-bakuneset-01",
      },
      {
        documentIds: ["67be9311f7605c28867c7f5d", "67f8b12874581f45ba3a68c5"],
        url: "/features/mothers-fathers-day-2025-bakuneset-09",
      },
      {
        documentIds: ["67be9311f7605c28867c7f5d", "67ca7b8ace9a365145b4d9a7"],
        url: "/features/mothers-fathers-day-2025-bakuneset-04",
      },
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67be95bff7605c28867d04bf"],
        url: "/features/mothers-fathers-day-2025-bakuneset-05",
      },
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67f8b12874581f45ba3a68c5"],
        url: "/features/mothers-fathers-day-2025-bakuneset-07",
      },
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67ca7b8ace9a365145b4d9a7"],
        url: "/features/mothers-fathers-day-2025-bakuneset-06",
      },
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67be95bff7605c28867d04bf"],
        url: "/features/mothers-fathers-day-2025-bakuneset-03",
      },
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67f8b12874581f45ba3a68c5"],
        url: "/features/mothers-fathers-day-2025-bakuneset-08",
      },
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67ca7b8ace9a365145b4d9a7"],
        url: "/features/mothers-fathers-day-2025-bakuneset-02",
      },
    ],
    otherItem: {
      title: "他にもあります！\n10%OFFで購入できる「BAKUNEペアパジャマ」",
      url: "/campaign/bakune_set",
    },
  },
  {
    title: "暑い夏の寝苦しさから解放してくれる",
    subTitle: "BAKUNE Dry ＋ 夏用掛け布団",
    productNames: "快適睡眠環境セット",
    description:
      "いつも自分の事は後回しで、家族の事ばかり優先しているお母さんに、日頃言えない「ありがとう」の想いを込めて。夏の夜の寝苦しさから解放してくれる、快適な睡眠環境を贈ってみませんか。BAKUNE Dryパジャマと夏用掛け布団のセットは、いつも優しいお母さんに、温かい想いを伝えてくれる、期間限定の特別セットです。",
    bakuneCategory: true,
    novelty: noveltySleepMist,
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Dry Men's / Women's",
        selectItems: [
          {
            index: 0,
            documentId: "67f8b05674581f45ba3a5ba3",
            selectName: "Men's （半袖Tシャツ＋ロングパンツ）",
            productName: "BAKUNE Dry Men’s",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short-and-long.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67f8b12874581f45ba3a68c5",
            selectName: "Women's （半袖Tシャツ＋ロングパンツ）",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ロングパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short-and-long.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Comforter Cool （掛け布団）",
        selectItems: [
          {
            index: 0,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67f8b05674581f45ba3a5ba3", "67bed5ea46cc55e963fefea2"],
        url: "/features/mothers-fathers-day-2025-comforterset-01",
      },
      {
        documentIds: ["67f8b12874581f45ba3a68c5", "67bed5ea46cc55e963fefea2"],
        url: "/features/mothers-fathers-day-2025-comforterset-02",
      },
    ],
  },
  {
    title: "暑い夏の寝苦しさから解放してくれる",
    subTitle: "BAKUNE Dry ＋ 夏用敷きパッド",
    productNames: "快適涼感セット",
    description:
      "昔から仕事が忙しくて帰りが遅かったお父さん。家にいる時くらいは、ゆっくりと快適な時間を過ごして欲しい。これから暑くなる季節にぴったりなBAKUNE Dryパジャマと敷きパッドのセットで快適な睡眠環境をプレゼント。温度調整素材×除湿素材×ひんやりニットで、朝まで快適に眠れますように。",
    bakuneCategory: true,
    novelty: noveltySleepMist,
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Dry Men's / Women's",
        selectItems: [
          {
            index: 0,
            documentId: "67ca6adcce9a365145b38d0c",
            selectName: "半袖Tシャツ＋ショートパンツ",
            productName: "BAKUNE Dry Men's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-mens-short.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67ca7b8ace9a365145b4d9a7",
            selectName: "半袖Tシャツ＋ショートパンツ",
            productName: "BAKUNE Dry Women's",
            subtext: "上下セット(半袖Tシャツ・ショートパンツ)",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-dry-womens-short.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Bed Pad Cool （敷きパッド）",
        selectItems: [
          {
            index: 0,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67ca6adcce9a365145b38d0c", "67bedac346cc55e963ff2281"],
        url: "/features/mothers-fathers-day-2025-bedpadset-01",
      },
      {
        documentIds: ["67ca7b8ace9a365145b4d9a7", "67bedac346cc55e963ff2281"],
        url: "/features/mothers-fathers-day-2025-bedpadset-02",
      },
    ],
  },
  {
    title: "理想的な寝床内環境を実現してくれる",
    subTitle: "夏用敷きパッド ＋ 掛け布団",
    productNames: "至福の寝具セット",
    description:
      "「よく眠れなかった」が口癖のお父さんにぴったりの新提案ギフト。BAKUNE Bed Pad Coolは暑さや蒸れ、冷房による寒さなど夏の睡眠課題を解決する新発想の敷きパッド。夏用掛け布団は、温度調整素材がエアコンによる肌寒さを防ぎ快適な寝床内環境にコンディショニング。暑いときは涼しく、ただ寒くなりすぎない理想的な寝床内温度へ近づけます。朝まで快適な睡眠環境を手に入れられる夏用寝具セットでお父さんに心地よい休息を届けましょう。",
    bakuneCategory: false,
    novelty: noveltySleepMist,
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-comforter-pc.png",
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-comforter-sp.png",
    discountLate: 10,
    selectedProducts: ["0", "0"],
    isNewItem: false,
    products: [
      {
        selectLabel: "BAKUNE Comforter Cool （掛け布団）",
        selectItems: [
          {
            index: 0,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bed5ea46cc55e963fefea2",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Comforter Cool",
            subtext: "掛け布団",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-comforter-cool-2.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "BAKUNE Bed Pad Cool （敷きパッド）",
        selectItems: [
          {
            index: 0,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "シングル",
            selectName: "シングル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "セミダブル",
            selectName: "セミダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 2,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "ダブル",
            selectName: "ダブル",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
          {
            index: 3,
            documentId: "67bedac346cc55e963ff2281",
            skuName: "クイーン",
            selectName: "クイーン",
            productName: "BAKUNE Bed Pad Cool",
            subtext: "敷きパッド",
            img: "/images/site/feature/mothers-fathers-day-2025/bakune-bed-pad-cool-3.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67bed5ea46cc55e963fefea2", "67bedac346cc55e963ff2281"],
        url: "/features/mothers-fathers-day-2025-comforterbedpadset",
      },
    ],
  },
  {
    title: "両親の健康を足元からささえる",
    subTitle: "リカバリーサンダル",
    productNames: "リカバリーサンダルペアセット",
    description:
      "両親には、いつまでも自分の足で元気に歩いてほしい――そんな願いを込めて贈るなら、アーチサポート構造を採用した「リカバリーサンダルペアセット」がおすすめです。室内、屋外を問わず、至福のやさしい履き心地で、軽やかなフットワークと健康をささえます。",
    bakuneCategory: false,
    bannerPc: "/images/site/feature/mothers-fathers-day-2025/set-sandal-pc.png",
    bannerSp: "/images/site/feature/mothers-fathers-day-2025/set-sandal-sp.png",
    discountLate: 10,
    selectedProducts: ["0", "1"],
    isNewItem: false,
    products: [
      {
        selectLabel: "1商品目",
        selectItems: [
          {
            index: 0,
            documentId: "67a3241473eead61841a241e",
            selectName: "Recovery Sandal Slide",
            productName: "Recovery Sandal Slide",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-slide.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "646d68ac7a3fbe961f40794f",
            selectName: "Recovery Sandal Flip-flop",
            productName: "Recovery Sandal Flip-flop",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-flip-flop.png",
            isInStock: true,
          },
        ],
      },
      {
        selectLabel: "2商品目",
        selectItems: [
          {
            index: 0,
            documentId: "67a3241473eead61841a241e",
            selectName: "Recovery Sandal Slide",
            productName: "Recovery Sandal Slide",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-slide.png",
            isInStock: true,
          },
          {
            index: 1,
            documentId: "646d68ac7a3fbe961f40794f",
            selectName: "Recovery Sandal Flip-flop",
            productName: "Recovery Sandal Flip-flop",
            subtext: "サンダル",
            img: "/images/site/feature/mothers-fathers-day-2025/recovery-sandal-flip-flop.png",
            isInStock: true,
          },
        ],
      },
    ],
    urlTable: [
      {
        documentIds: ["67a3241473eead61841a241e", "67a3241473eead61841a241e"],
        url: "/features/mothers-fathers-day-2025-sandalset-02",
      },
      {
        documentIds: ["67a3241473eead61841a241e", "646d68ac7a3fbe961f40794f"],
        url: "/features/mothers-fathers-day-2025-sandalset-01",
      },
      {
        documentIds: ["646d68ac7a3fbe961f40794f", "646d68ac7a3fbe961f40794f"],
        url: "/features/mothers-fathers-day-2025-sandalset-03",
      },
    ],
    otherItem: {
      title: "他にもあります！\n10%OFFで購入できる「リカバリーペアサンダル」",
      url: "/features/sandal_set_2023",
    },
  },
]
